<template>
	<div>
		<div class="btn-toolbar pull-right visible-lg visible-md visible-sm" role="toolbar">
			<div class="btn-group form-inline" role="group" aria-label="...">
				<div class="input-group">
					<span class="input-group-addon">
						<input type="checkbox" v-model="filter.allowDate">
					</span>
					<input type="text" v-model="filter.date" class="form-control daterange" :class="{ disabled: !filter.allowDate }" id="daterange" placeholder="Rango de fecha">
				</div>
			</div>
			<div class="btn-group form-inline">
				<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
			</div>
			<div class="btn-group" role="group" aria-label="...">
				<button
					title="Filtrar"
					ref="btnfilter"
					@click="doFilter()"
					data-style="slide-left"
					class="btn btn-default">
					<i class="fa fa-search" aria-hidden="true"></i>
				</button>
				<button
					title="Restablecer"
					ref="btnreset"
					@click="reset()"
					data-style="slide-left"
					class="btn btn-default">
					<i class="fa fa-refresh" aria-hidden="true"></i>
				</button>
			</div>
		</div>
		<div class="visble-xs hidden-lg hidden-md hidden-sm">
			<div id="filter" ref="filter" class="collapse">
				<div class="row">
					<div class="col-md-12 m-b-5">
						<div class="input-group">
							<span class="input-group-addon">
								<input type="checkbox" v-model="filter.allowDate">
							</span>
							<input type="text" v-model="filter.date" class="form-control daterange" :class="{ disabled: !filter.allowDate }" id="daterange" placeholder="Rango de fecha">
							<span class="input-group-btn">
								<button
									title="Filtrar"
									ref="btnfilter"
									@click="doFilter()"
									data-style="slide-left"
									class="btn btn-default">
									<i class="fa fa-search" aria-hidden="true"></i>
								</button>
							</span>
						</div>
					</div>
					<div class="col-md-12  m-b-5">
						<div class="input-group">
							<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
							<span class="input-group-btn">
								<button
									title="Restablecer"
									ref="btnreset"
									@click="reset()"
									data-style="slide-left"
									class="btn btn-default">
									<i class="fa fa-refresh" aria-hidden="true"></i>
								</button>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		components: {

		},
		data () {
			return {
				projects: null,
				users: null,

				filter: {
					date: null,
					allowDate: false,
					text: null,
				}
			}
		},
		watch: {
			'filter.allowDate'() {
				this.initDate()
			}
		},
		methods: {
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(!this.filter.allowDate) {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.date = null
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			initDate() {
				var that = this
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('.daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				}).on('hide.daterangepicker', function(e, picker) {
					that.filter.date = moment(picker.startDate).format('DD/MM/YY') + ' - ' +moment(picker.endDate).format('DD/MM/YY')
				})
				this.filter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/FilterBar.vue